import React from 'react';
import Navigation from '../Shared/Navigation/Navigation';
import './AllBlog.css'
import b3 from '../../images/b-3.png';
import b2 from '../../images/b-2.png';
import b1 from '../../images/b-1.png';
import Footer from '../Shared/Footer/Footer';

const AllBlog = () => {
    return (
        <>
            <Navigation />
            <section className="mh-blog pt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 d-flex justify-content-between align-items-center">
                            <h3 data-aos-duration="1000" data-aos='fade-right'>My Blogs</h3>
                            <a href="https://shahinur-alam-bhuiyan01.medium.com" target="_blank">
                                <button className="btn btn-danger" data-aos="flip-left"  data-aos-duration="1000">
                                    See all of my blogs&nbsp; <i class="fa fa-arrow-right"></i>
                                </button>
                            </a>
                        </div>
                        <br /><br /><br />
                        <div className="col-md-4" data-aos="flip-left" data-aos-duration="800">
                            <div className="mh-blog-item dark-bg">
                                <img src={b3} alt="" className="img-fluid" />
                                <div className="blog-inner">
                                    <h4 className='pt-2 '>JavaScript</h4>
                                    <div className="mh-blog-post-info pt-3">
                                        <ul>
                                            <li>Post on <a href="">05.05.21</a></li>
                                            <li>By <a href="https://shahinur-alam-bhuiyan01.medium.com/" target="_blank">Shahinur Alam Bhuiyan</a></li>
                                        </ul>
                                    </div>
                                    <p>It is a flexible and powerful programming language that is implemented consistently by various web browsers. This language can be used in both the front-end and back-end of web development. It’s offer a wide . . .</p>
                                    <a href="https://shahinur-alam-bhuiyan01.medium.com/javascript-585db449dbbf" target="_blank">Read more</a>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4" data-aos="flip-left" data-aos-duration="1000">
                            <div className="mh-blog-item dark-bg">
                                <img src={b2} alt="" className="img-fluid" />
                                <div className="blog-inner">
                                    <h4 className='pt-2'>Boost Your JavaScript Sense !</h4>
                                    <div className="mh-blog-post-info pt-3">
                                        <ul>
                                            <li>Post on <a href="">25.11.21</a></li>
                                            <li>By <a href="https://shahinur-alam-bhuiyan01.medium.com/" target="_blank">Shahinur Alam Bhuiyan</a></li>
                                        </ul>
                                    </div>
                                    <p>Data Types: In JavaScript there is two kinds of data types. First one is Primitive data types and Second one is Non-primitive data types. In javascript a primitive is data that  . . .</p>
                                    <a href="https://shahinur-alam-bhuiyan01.medium.com/boost-your-javascript-sense-4b6f1161229a" target="_blank">Read more</a>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-4" data-aos="flip-left" data-aos-duration="1200">
                            <div className="mh-blog-item dark-bg">
                                <img src={b1} alt="" className="img-fluid" />
                                <div className="blog-inner">
                                    <h4 className='pt-2 '>A little bit about React</h4>
                                    <div className="mh-blog-post-info pt-3">
                                        <ul>
                                            <li>Post on <a href="">08.05.21</a></li>
                                            <li>By <a href="https://shahinur-alam-bhuiyan01.medium.com/" target="_blank">Shahinur Alam Bhuiyan</a></li>
                                        </ul>
                                    </div>
                                    <p>React is an open-source, front-end , javascript library for building user interface or UI components. This library maintained by popular social network which is facebook and a community of individual developers and companies . . .</p>
                                    <a href="https://shahinur-alam-bhuiyan01.medium.com/a-liabout-react-fa516d965944" target="_blank">Read more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AllBlog;